module.exports = __webpack_public_path__ + "img/monkey.be5030ca.webp";